var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOvbYclUg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1062_3210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#3F3F3F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6416 28.924C23.6345 29.3382 23.9645 29.6797 24.3786 29.6868C24.7928 29.6939 25.1343 29.364 25.1414 28.9498L23.6416 28.924ZM25.0847 19.4787C24.7968 19.1809 24.322 19.1727 24.0242 19.4605L19.1698 24.1507C18.8719 24.4385 18.8637 24.9133 19.1515 25.2112C19.4393 25.509 19.9141 25.5172 20.212 25.2294L24.527 21.0604L28.6961 25.3754C28.9839 25.6733 29.4587 25.6814 29.7566 25.3936C30.0545 25.1058 30.0626 24.631 29.7748 24.3331L25.0847 19.4787ZM25.1414 28.9498L25.2952 20.0128L23.7954 19.987L23.6416 28.924L25.1414 28.9498Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9901 16.9979L34.9988 31.8549C34.9991 32.4052 34.5537 32.852 33.9991 32.8521L14.0002 32.8567C13.4479 32.8568 13 32.4091 13 31.8567V17C13 16.4477 13.4477 16 14 16H33.9901C34.5431 16 34.9898 16.4468 34.9901 16.9979Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1062_3210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvbYclUg);
export default __webpack_public_path__ + "static/media/ovbYclUg.777a73274826cd9ed285d089125fe20e.svg";
export { ForwardRef as ReactComponent };